var map = {
	"./drag_m.webp": 4651,
	"./lambert_long_m.webp": 6097,
	"./lambert_m.webp": 8298,
	"./language/a1_m.webp": 3338,
	"./language/a2_m.webp": 1871,
	"./language/a3_m.webp": 7748,
	"./language/b1_m.webp": 1089,
	"./language/b2_m.webp": 840,
	"./language/b3_m.webp": 1299,
	"./language/c1_m.webp": 4796,
	"./language_m.webp": 435,
	"./newonce/a1_m.webp": 2815,
	"./newonce/a2_m.webp": 4282,
	"./newonce/b1_m.webp": 2543,
	"./newonce/b2_m.webp": 3285,
	"./newonce_m.webp": 3472,
	"./punk_m.webp": 4657,
	"./sso_m.webp": 6828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2495;